import { parseUniqueId } from '../key-parsing.ts'

export type PitchTypeColorMode = 'group03' | 'group09' | 'none'

function getUniquePitchValues(
    uniqueIds: string[],
    groupBys: string[],
    pitchGroupField: 'api_pitch_type_group03' | 'api_pitch_type_group09'
): string[] | null {
    const pitchTypes = uniqueIds.map((uniqueId) => {
        const unique = parseUniqueId(uniqueId, groupBys)

        return typeof unique[pitchGroupField] === 'string'
            ? unique[pitchGroupField]
            : null
    })

    if (pitchTypes.some((pitchType) => pitchType === null)) {
        return null
    }

    return pitchTypes as string[]
}

export function getPitchTypeColorModeByUniqueId(
    uniqueIds: string[],
    groupBys: string[]
): PitchTypeColorMode {
    const group03PitchTypes = getUniquePitchValues(
        uniqueIds,
        groupBys,
        'api_pitch_type_group03'
    )

    if (
        group03PitchTypes &&
        new Set(group03PitchTypes).size === group03PitchTypes.length
    ) {
        return 'group03'
    }

    const group09PitchTypes = getUniquePitchValues(
        uniqueIds,
        groupBys,
        'api_pitch_type_group09'
    )

    if (
        group09PitchTypes &&
        new Set(group09PitchTypes).size === group09PitchTypes.length
    ) {
        return 'group09'
    }

    return 'none'
}

export default function canUsePitchTypeColors(
    uniqueIds: string[],
    groupBys: string[]
): boolean {
    return getPitchTypeColorModeByUniqueId(uniqueIds, groupBys) !== 'none'
}
